import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* checkReimbursementBalance({ payload: { values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.reimbursements.check_balance, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.checkReimbursementBalanceDone(data.result));
  } catch (error) {
    onError && onError();
    yield handleErrors({
      error,
      putErrorData: actions.checkReimbursementBalanceFailed,
      handledErrors,
      endpoint: api.reimbursements.check_balance.url
    });
  }
}

export const checkReimbursementBalanceSaga = takeEvery(
  types.CHECK_REIMBURSEMENT_BALANCE_REQUEST,
  checkReimbursementBalance
);